export default __webpack_public_path__ + "static/media/RebaseLogoWhite.ae282e78.svg";